import apiClient from '../api/apiClient';
import type { ServiceCategory } from '../constants/serviceCategories';

export interface StylistPromotion {
  _id: string;
  stylist: string;
  title: string;
  description?: string;
  discountType: 'percentage' | 'fixed';
  discountValue: number;
  minBookingAmount?: number;
  maxDiscountAmount?: number;
  serviceCategory: ServiceCategory;
  startDate?: string;
  endDate?: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreatePromotionData {
  title: string;
  description?: string;
  discountType: 'percentage' | 'fixed';
  discountValue: number;
  minBookingAmount?: number;
  maxDiscountAmount?: number;
  serviceCategory?: ServiceCategory;
  startDate?: string;
  endDate?: string;
  isActive?: boolean;
}

const promotionService = {
  getMyPromotions: async (): Promise<StylistPromotion[]> => {
    const res = await apiClient.get('/promotions/mine');
    return res.data.data as StylistPromotion[];
  },

  getStylistPromotions: async (
    stylistId: string,
    serviceCategory?: string
  ): Promise<StylistPromotion[]> => {
    const params: Record<string, string> = {};
    if (serviceCategory) {
      params.serviceCategory = serviceCategory; // axios handles URL encoding
    }
    const res = await apiClient.get(`/promotions/stylist/${stylistId}`, { params });
    return res.data.data as StylistPromotion[];
  },

  createPromotion: async (data: CreatePromotionData): Promise<StylistPromotion> => {
    const res = await apiClient.post('/promotions', data);
    return res.data.data as StylistPromotion;
  },

  updatePromotion: async (
    id: string,
    data: Partial<CreatePromotionData>
  ): Promise<StylistPromotion> => {
    const res = await apiClient.put(`/promotions/${id}`, data);
    return res.data.data as StylistPromotion;
  },

  deletePromotion: async (id: string): Promise<void> => {
    await apiClient.delete(`/promotions/${id}`);
  },

  togglePromotion: async (id: string, isActive: boolean): Promise<StylistPromotion> => {
    const res = await apiClient.put(`/promotions/${id}`, { isActive });
    return res.data.data as StylistPromotion;
  },
};

export default promotionService;
